import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Grid, makeStyles, Typography } from "@material-ui/core";
import Paginacao from '../../../shared/components/Paginacao';
import Loading from "../../../shared/components/Loading";
import ScrollBarGradiente from "../../../shared/components/ScrollBarGradiente";
import { formatarCodigoLote, formatarValorCasasDecimais } from '../../../shared/utils/Formatacao';
import ListaAmostrasLote from './ListaAmostrasLote';
import DadosLateralDireita from './DadosLateralDireita';
import DadosLotesManager from '../DadosLotesManager';
import { v4 as uuidv4 } from 'uuid';
import { codigosErros } from '../../../shared/utils/Constantes'
import { SECONDARY_COLOR } from "../../../theme";
import FiltrosAmostrasDisponiveis from "./FiltrosAmostrasDisponiveis";
import FiltrosAmostrasNoLote from "./FiltrosAmostrasNoLote";
import ContainerPagina from "../../../shared/components/ContainerPagina";
import ReactDOM from "react-dom";

const PAGINA_INICIAL = 1
const ITENS_PAGINA_INICIAL = 15;
const FILTROS_INICIAL = {
    busca: '',
    tipos: [],
}

const SelecaoAmostrasLote = ({ dadosLote, handleEditarDados, editando, ehLoteKPA }) => {
    const classes = useStyles();
    const [possuiAmostras, setPossuiAmostras] = useState(true);
    const [carregandoAmostras, setCarregandoAmostras] = useState(true);
    const [carregandoInclusaoAmostra, setCarregandoInclusaoAmostra] = useState(false);
    const [quantidadeItensPorPagina, setQuantidadeItensPorPagina] = useState(ITENS_PAGINA_INICIAL);
    const [indexPaginaAtual, setIndexPaginaAtual] = useState(0);
    const [listaAmostrasDisponiveis, setListaAmostrasDisponiveis] = useState([]);
    const [listaAmostrasInclusas, setListaAmostrasInclusas] = useState([]);
    const [opcoesTipos, setOpcoesTipos] = useState([])
    const [quantidadeTotalItens, setQuantidadeTotalItens] = useState(null);
    const [selecionandoAmostras, setSelecionandoAmostras] = useState(false);
    const [quantidadeAmostrasLote, setQuantidadeAmostrasLote] = useState(0);
    const [codigoAmostra, setCodigoAmostra] = useState("");
    const [filtrosAplicados, setFiltrosAplicados] = useState(true);

    const contadorCarregandoAmostras = useRef(0);
    const ultimoUUIDRequisicao = useRef("");
    const codigoAmostraRef = useRef();
    const filtrosRef = useRef(FILTROS_INICIAL);

    const [paginacao, setPaginacao] = useState({
        pagina: PAGINA_INICIAL,
        itensPagina: ITENS_PAGINA_INICIAL,
    });

    const [filtros, setFiltros] = useState(FILTROS_INICIAL);

    const retornoDesabilitado = carregandoAmostras || indexPaginaAtual === 0;
    const avancoDesabilitado =
        !possuiAmostras ||
        carregandoAmostras ||
        (selecionandoAmostras && listaAmostrasDisponiveis.length === quantidadeTotalItens) ||
        (selecionandoAmostras && listaAmostrasDisponiveis.length < quantidadeItensPorPagina) ||
        (!selecionandoAmostras && listaAmostrasInclusas.length === quantidadeTotalItens) ||
        (!selecionandoAmostras && listaAmostrasInclusas.length < quantidadeItensPorPagina);


    const incrementarContadorCarregandoAmostras = useCallback(() => {
        contadorCarregandoAmostras.current++;
        setCarregandoAmostras(true);
    }, [])

    const decrementarContadorCarregandoAmostras = useCallback(() => {
        if (contadorCarregandoAmostras.current > 0) {
            contadorCarregandoAmostras.current--;
        }
        if (contadorCarregandoAmostras.current === 0) {
            setCarregandoAmostras(false);
        }
    }, [])

    const listarAmostrasLote = useCallback(async (
        filtrosParam,
        paginacaoParam,
        selecionandoAmostrasParam,
        sobrescreverQuantidadeAmostrasInclusas) => {

        incrementarContadorCarregandoAmostras();

        const operacoesListagem = {
            idLote: selecionandoAmostrasParam ? null : dadosLote.id,
            filtros: filtrosParam,
            somenteNaoInclusasEmLote: selecionandoAmostrasParam ? true : false,
            idTipoConservacaoLote: dadosLote.tipoConservacao?.id,
            filtrarPorDescricaoTipoAmostra: !selecionandoAmostrasParam,
            paginacao: paginacaoParam,
            idEmpresa: dadosLote.empresa?.id
        }
        ultimoUUIDRequisicao.current = uuidv4();
        const resultado = await DadosLotesManager.listarAmostrasLote(operacoesListagem, ultimoUUIDRequisicao.current);

        if (resultado && resultado.itens && resultado.itens.length > 0) {
            if (resultado.uuid === ultimoUUIDRequisicao.current) {
                if (selecionandoAmostrasParam) {
                    setListaAmostrasDisponiveis(resultado.itens);
                }
                else {
                    setListaAmostrasInclusas(resultado.itens);
                    if (sobrescreverQuantidadeAmostrasInclusas) {
                        setQuantidadeAmostrasLote(resultado.totalItens);
                    }
                }
                setPossuiAmostras(true);
            }
        }
        else {
            if (selecionandoAmostrasParam) {
                setListaAmostrasDisponiveis([]);
            }
            else {
                setListaAmostrasInclusas([]);
            }
            setPossuiAmostras(false);
        }

        setQuantidadeTotalItens(resultado?.totalItens);
        decrementarContadorCarregandoAmostras();
        setFiltrosAplicados(true);
    }, [incrementarContadorCarregandoAmostras, decrementarContadorCarregandoAmostras, dadosLote])

    const obterPaginaInicial = () => {
        if ((selecionandoAmostras && listaAmostrasDisponiveis && listaAmostrasDisponiveis.length === 0) ||
            (!selecionandoAmostras && listaAmostrasInclusas && listaAmostrasInclusas.length === 0)) return 0

        const paginaAtual = indexPaginaAtual === 0 ? 1 : indexPaginaAtual

        return formatarValorCasasDecimais((paginaAtual - PAGINA_INICIAL) * quantidadeItensPorPagina + 1)
    }

    const obterPaginaFinal = () => {
        if ((selecionandoAmostras && listaAmostrasDisponiveis && listaAmostrasDisponiveis.length === 0) ||
            (!selecionandoAmostras && listaAmostrasInclusas && listaAmostrasInclusas.length === 0)) return 0

        const paginaAtual = indexPaginaAtual === 0 ? 1 : indexPaginaAtual
        const tamanhoLista = selecionandoAmostras ? listaAmostrasDisponiveis.length : listaAmostrasInclusas.length
        return formatarValorCasasDecimais((paginaAtual - PAGINA_INICIAL) * quantidadeItensPorPagina + tamanhoLista)
    }

    const handleInserirAmostra = async (idAmostra) => {
        const dados = {
            idLote: dadosLote.id,
            idAmostra: idAmostra
        }

        setCarregandoAmostras(true);

        const response = await DadosLotesManager.inserirAmostraLote(dados, ehLoteKPA);

        if (!response.error) {
            const amostraInclusa = listaAmostrasDisponiveis.find(amostra => amostra.id === idAmostra);

            setListaAmostrasInclusas(listaAmostrasInclusas.concat([amostraInclusa]));
            setListaAmostrasDisponiveis(listaAmostrasDisponiveis.filter((amostra) => amostra.id !== idAmostra));

            setQuantidadeTotalItens(quantidadeTotalItens - 1);
            setQuantidadeAmostrasLote(quantidadeAmostrasLote + 1);

            listarAmostrasLote(filtros, paginacao, selecionandoAmostras);
        }
        else if (response.codigoErro === codigosErros.AmostraEmOutroLote) {
            setListaAmostrasDisponiveis(listaAmostrasDisponiveis.filter((amostra) => amostra.id !== idAmostra));
            setQuantidadeTotalItens(quantidadeTotalItens - 1);

            listarAmostrasLote(filtros, paginacao, selecionandoAmostras);
        }

        setCarregandoAmostras(false);
    }

    const handleExcluirAmostra = async (idAmostra, codigoAmostra) => {
        const dados = {
            idLote: dadosLote.id,
            idAmostra: idAmostra,
            codigoAmostra: codigoAmostra
        }

        setCarregandoAmostras(true);

        const response = await DadosLotesManager.excluirAmostraLote(dados);

        if (!response.error) {
            const amostraExcluida = listaAmostrasInclusas.find(amostra => amostra.id === idAmostra);

            setListaAmostrasDisponiveis(listaAmostrasDisponiveis.concat([amostraExcluida]));
            setListaAmostrasInclusas(listaAmostrasInclusas.filter((amostra) => amostra.id !== idAmostra));

            setQuantidadeTotalItens(quantidadeTotalItens - 1);
            setQuantidadeAmostrasLote(quantidadeAmostrasLote - 1);

            listarAmostrasLote(filtros, paginacao, selecionandoAmostras);
        }
        else if (response.codigoErro === codigosErros.AmostraNaoExisteNoLote) {
            setListaAmostrasInclusas(listaAmostrasInclusas.filter((amostra) => amostra.id !== idAmostra));
            setQuantidadeTotalItens(quantidadeTotalItens - 1);

            listarAmostrasLote(filtros, paginacao, selecionandoAmostras);
        }

        setCarregandoAmostras(false);
    }

    const handleChangeItensPorPagina = (event) => {
        setQuantidadeItensPorPagina(event.target.value)
        setPaginacao({
            ...paginacao,
            pagina: PAGINA_INICIAL,
            itensPagina: event.target.value,
        })

        if (selecionandoAmostras) {
            setListaAmostrasDisponiveis([]);
        }
        else {
            setListaAmostrasInclusas([]);
        }
        setIndexPaginaAtual(0);
    }

    const handleChangePagina = (avanco) => {
        const paginaAtual = indexPaginaAtual === 0 ? 1 : indexPaginaAtual
        const paginaAVisualizar = avanco ? paginaAtual + 1 : paginaAtual - 1
        setIndexPaginaAtual(paginaAVisualizar === 1 ? 0 : paginaAVisualizar)
        setPaginacao({
            ...paginacao,
            pagina: paginaAVisualizar,
            itensPagina: quantidadeItensPorPagina,
        })

        if (selecionandoAmostras) {
            setListaAmostrasDisponiveis([]);
        }
        else {
            setListaAmostrasInclusas([]);
        }
    }

    const voltarPaginaInicial = () => {
        setPaginacao({
            ...paginacao,
            pagina: PAGINA_INICIAL,
        })
        setIndexPaginaAtual(0);
    }

    const handleAlterarExibicaoAmostras = () => {
        setSelecionandoAmostras(!selecionandoAmostras);
        setCodigoAmostra("");

        setFiltros(FILTROS_INICIAL);
        voltarPaginaInicial();
    }

    const handleChangeFiltros = (novosFiltros) => {
        const filtrosMudaram = 
            novosFiltros.busca !== filtrosRef.current.busca ||
            (filtrosRef.current.tipos && novosFiltros.tipos.length !== filtrosRef.current.tipos.length);

        if (filtrosMudaram){
            filtrosRef.current = novosFiltros;
            
            ReactDOM.unstable_batchedUpdates(() => {
                setFiltros(novosFiltros);

                if (paginacao.pagina !== PAGINA_INICIAL){
                    voltarPaginaInicial();
                }
            });
        }
    }

    const handleChangeCodigoAmostra = (event) => {
        setCodigoAmostra(event.target.value);
    }

    const handleEnterDownCampoLeitor = async () => {
        if (codigoAmostra) {
            const dados = {
                idLote: dadosLote.id,
                codigoAmostra: codigoAmostra
            }

            setCarregandoInclusaoAmostra(true);
            const response = await DadosLotesManager.inserirAmostraLote(dados, ehLoteKPA);

            if (!response.error) {
                setListaAmostrasInclusas([response].concat(listaAmostrasInclusas));
                setQuantidadeTotalItens(quantidadeTotalItens + 1);
                setQuantidadeAmostrasLote(quantidadeAmostrasLote + 1);
            }

            if (codigoAmostraRef?.current) {
                codigoAmostraRef.current.blur();
                setTimeout(() => {
                    codigoAmostraRef.current.focus();
                }, 1);
            }
            setCodigoAmostra("");
            setCarregandoInclusaoAmostra(false);
        }
    }

    useEffect(() => {
        DadosLotesManager.listarTiposAmostra().then(tipos => setOpcoesTipos(tipos));
    }, [])

    useEffect(() => {
        listarAmostrasLote(filtros, paginacao, selecionandoAmostras);
    }, [listarAmostrasLote, filtros, paginacao, selecionandoAmostras]);

    useEffect(() => {
        if (editando) {
            setSelecionandoAmostras(false);
            listarAmostrasLote(FILTROS_INICIAL, PAGINA_INICIAL, false, true);
        }
        else {
            listarAmostrasLote(FILTROS_INICIAL, PAGINA_INICIAL, false);
            setSelecionandoAmostras(false);
        }
    }, [editando, listarAmostrasLote]);

    return (
        <ContainerPagina>
            <Grid container spacing={3}>
                <Grid item xs={9}>
                    <Grid item xs={12} className="mt-4 mb-8">
                        {editando ?
                            <Typography variant="h2">
                                <span className={classes.editando}>
                                    Editando
                                </span>
                                lote {formatarCodigoLote(dadosLote.codigo)}
                            </Typography> :
                            <Typography variant="h2">
                                Lote {formatarCodigoLote(dadosLote.codigo)}
                            </Typography>
                        }
                    </Grid>

                    <Grid item xs={12} className="mb-6">
                        <Typography variant="h4">
                            {selecionandoAmostras ? "Amostras disponíveis" : "Amostras no lote"}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} className="pb-2">
                        {selecionandoAmostras
                            ? <FiltrosAmostrasDisponiveis
                                filtros={filtros}
                                handleChangeFiltros={handleChangeFiltros}
                                tiposOpcoes={opcoesTipos}
                            />
                            : <FiltrosAmostrasNoLote
                                filtros={filtros}
                                handleChangeFiltros={handleChangeFiltros}
                                codigoAmostra={codigoAmostra}
                                handleChangeCodigoAmostra={handleChangeCodigoAmostra}
                                handleEnterDown={handleEnterDownCampoLeitor}
                                carregando={carregandoInclusaoAmostra}
                                codigoAmostraRef={codigoAmostraRef}
                                ehLoteKPA={ehLoteKPA}
                            />
                        }
                    </Grid>

                    {carregandoAmostras
                        ? (<Grid item xs={12} className={classes.loading}>
                            <Loading loading size={30} className={"mt-0 mb-0"} />
                        </Grid>) :
                        (<Grid item xs={12} className={classes.containerTabela}>
                            <ScrollBarGradiente
                                estilo={{
                                    height: "100%",
                                    width: "100%",
                                }}
                                larguraGradiente={"0"}
                            >
                                <ListaAmostrasLote
                                    listaAmostrasLote={selecionandoAmostras ? listaAmostrasDisponiveis : listaAmostrasInclusas}
                                    handleInserirAmostra={handleInserirAmostra}
                                    handleExcluirAmostra={handleExcluirAmostra}
                                    selecionandoAmostras={selecionandoAmostras}
                                    filtrando={!filtrosAplicados || (filtros.busca || filtros.tipos.length)}
                                />

                            </ScrollBarGradiente>
                        </Grid>)
                    }
                </Grid>

                <Grid item xs={3}>
                    <DadosLateralDireita
                        dadosLote={dadosLote}
                        selecionandoAmostras={selecionandoAmostras}
                        quantidadeAmostrasLote={quantidadeAmostrasLote}
                        handleAlterarExibicaoAmostras={handleAlterarExibicaoAmostras}
                        handleClickEditarDados={handleEditarDados}
                        editando={editando}
                        carregando={carregandoInclusaoAmostra}
                    />
                </Grid>

                <Paginacao
                    quantidadeItensPorPagina={quantidadeItensPorPagina}
                    retornoDesabilitado={retornoDesabilitado}
                    avancoDesabilitado={avancoDesabilitado}
                    quantidadeTotalItens={quantidadeTotalItens === null ? 0 : formatarValorCasasDecimais(quantidadeTotalItens)}
                    inicioPagina={() => obterPaginaInicial()}
                    finalPagina={() => obterPaginaFinal()}
                    handleChangeSelect={(event) => handleChangeItensPorPagina(event)}
                    mudarPagina={handleChangePagina}
                    textoExibicao={selecionandoAmostras ? "Exibindo amostras disponíveis" : "Exibindo amostras no lote"}
                />
            </Grid>
        </ContainerPagina>
    );
}

const useStyles = makeStyles((theme) => ({
    containerTabela: {
        height: "calc(90vh - 278px)",
    },
    editando: {
        color: SECONDARY_COLOR,
        paddingRight: "6px"
    },
    loading: {
        height: "calc(100vh - 320px)",
        display: "flex",
        alignItems: "center",
    },
}))

export default SelecaoAmostrasLote;